import React from 'react';
import type { SearchCreditOverview } from '@retro-ui/api-contract';

interface CreditOverviewContext {
  creditOverview?: SearchCreditOverview;
  updateCreditOverview: () => Promise<void>;
}

export const CreditOverviewContext = React.createContext<CreditOverviewContext>({
  creditOverview: undefined,
  updateCreditOverview: () => Promise.resolve(),
});
